module.exports = __webpack_public_path__ + "static/media/cclogo.8465c038.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cclogo.png
// module id = 763
// module chunks = 0